module.exports = __webpack_public_path__ + "src/assets/img/domogakov.62089225.png";